import styled from 'styled-components';
import CustomDrawerGenie from '../../../pages/ChatGenie/Sql/Drawer';

const MetaGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: clamp(0.375rem, 0.7vw, 0.625rem);
  margin-left: auto;
  /* Allow the cluster to shrink so SQL + time stay inline beside
     like/dislike on narrow viewports rather than wrapping. */
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  background: transparent;
`;

const TimeText = styled.span`
  font-size: clamp(0.625rem, 0.75vw, 0.8125rem);
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.04em;
`;

const MemoryText = styled.span`
  font-style: italic;
  font-size: clamp(0.625rem, 0.75vw, 0.8125rem);
  color: #6b7280;
`;

interface MessageMetaProps {
  msg?: any;
}

const MessageMeta = ({msg}: MessageMetaProps) => {
  const hasSql = msg?.sqlData && msg?.sqlData?.length > 0;
  const hasTime = msg?.timeTaken !== undefined;
  const answeredFromMemory = msg?.answeredFromMemory === true;

  if (!hasSql && !hasTime && !answeredFromMemory) return null;

  return (
    <MetaGroup>
      {hasSql && (
        <CustomDrawerGenie
          query={msg?.sqlData}
          traceId={msg?.traceId}
        />
      )}
      {answeredFromMemory && <MemoryText>Retrieved from Memory</MemoryText>}
      {hasTime && (
        <TimeText>
          {`${msg?.timeTaken ? (msg?.timeTaken / 1000)?.toFixed(1) : 0} Sec`}
        </TimeText>
      )}
    </MetaGroup>
  );
};

export default MessageMeta;
